import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { AnalyticsEvents } from '../../../enums/AnalyticsEvents';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { AgentCapability } from '../../../interfaces/Agent';
import StyledFormItem from '../../../styles/StyledFormItem';
import Dropdown from '../../shared/DropDown/DropDown';
import Text from '../../shared/Text/Text';

type CapabilityOption = {
  label: string;
  value: AgentCapability;
};

interface ChooseCapabilityProps {
  capabilities: CapabilityOption[];
}

/**
 * @deprecated by ChooseCapabilityV1
 */
const ChooseCapability: React.FC<ChooseCapabilityProps> = ({
  capabilities,
}) => {
  const { setValue } = useFormContext();
  const { track } = useAnalytics();

  const handleCapabilityChange = useCallback((value: string) => {
    setValue('external_capabilities', value);
    if (value) {
      track(AnalyticsEvents.AGENT_CAPABILITY_CHOSEN, { capability: value });
    }
  }, []);

  return (
    <StyledFormItem>
      <Text type="label">{`Choose a capability`}</Text>
      <Dropdown
        name="external_capabilities"
        options={capabilities}
        fullWidth
        onChange={event => handleCapabilityChange(event.target.value)}
      />
    </StyledFormItem>
  );
};

export default ChooseCapability;
